/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum IndicatorHistoriesAliases {
  ACTION_ADD_HISTORY = 'action-add-history',
  AUTOCOMPLETE_HISTORY_TYPE = 'autocomplete-history-type',
  AVATAR_0 = 'avatar-0',
  CARD_HISTORY = 'card-history',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_HISTORIES = 'deck-histories',
  FETCH_HISTORIES = 'fetch-histories',
  FETCH_HISTORY = 'fetch-history',
  FETCH_LOCATOR = 'fetch-locator',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_AVATAR = 'field-avatar',
  FIELD_DS_HISTORY = 'field-dsHistory',
  FORM_0 = 'form-0',
  FORM_ADD_HISTORY = 'form-add-history',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_AUTOCOMPLETE = 'mapper-autocomplete',
  MODAL_ADD_HISTORY = 'modal-add-history',
  MODAL_HISTORY = 'modal-history',
  PANEL_0 = 'panel-0',
  PANEL_ADD_HISTORY = 'panel-add-history',
  PANEL_HISTORY = 'panel-history',
  PANEL_INDICATOR_HISTORIES = 'panel-indicator-histories',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_AUTOCOMPLETE = 'text-autocomplete',
}
export { IndicatorHistoriesAliases };
